import React from "react";

interface AlertTriangleIconProps {
  width?: number;
  height?: number;
  className?: string;
}

export const AlertTriangleIcon: React.FC<AlertTriangleIconProps> = ({
  width = 18,
  height = 18,
  className = "",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      className={className}
    >
      <path
        d="M1.19412 9.04929L5.30656 1.94598C5.53384 1.55339 5.64749 1.3571 5.79575 1.29118C5.92508 1.23367 6.07272 1.23367 6.20205 1.29118C6.35032 1.3571 6.46396 1.55339 6.69124 1.94598L10.8037 9.04929C11.0318 9.44328 11.1458 9.64028 11.129 9.80196C11.1143 9.94299 11.0404 10.0711 10.9257 10.1545C10.7942 10.2501 10.5666 10.2501 10.1113 10.2501H1.88646C1.4312 10.2501 1.20357 10.2501 1.07209 10.1545C0.957408 10.0711 0.883523 9.94299 0.86882 9.80196C0.851963 9.64028 0.966015 9.44328 1.19412 9.04929Z"
        fill="#BB0202"
      />
      <path
        d="M6 4.5V6.5M6 8.5H6.005"
        stroke="#FAE6E6"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
